<template>
    <div class="contain">
        
        <Header :config="config"  />

        <div class="main-container">
            
            <sidebar  />

            <div class="main-content">
                <div  class="main-userinfo" >
                    <div class="avatar">
                        <img style="width:155px;height:155px;border-radius:50%;" :src="userHomeInfo.avatar" />
                    </div>
                    <div class="info-part">
                        <div class="username">{{userHomeInfo.nickname}}</div>
                       
                        <div class="user-interactions">
                            <span>{{userHomeInfo.fans_num}} 粉丝</span>
                            <span>{{userHomeInfo.follow}} 关注</span>
                            <span>{{userHomeInfo.article_num}} 动态</span>
                        </div>


                        <el-button @click="handleFollow"  v-if="isLogin && userHomeInfo.is_follow == 0 " round type="danger">关注</el-button>
                     
                    </div>
                </div>
                <div class="main-page" ref="pageLists"  id="osComponentRef">
                    <div class="channel-container">
                        <span @click="handleTab(0)"  :class="activeChannel" class="channel ">笔记</span>

                        <span @click="handleTab(1)"  :class="activeChannel1" class="channel">收藏</span>
                    </div>

                 
                    <div class="page-list"  v-masonry transition-duration="0s" item-selector=".note-item">
                        <div class="note-item"  v-masonry-tile  v-for="(column,index) in contentArr" :key="index" >
                            <article-list :column=column />
                        </div>
                    </div>
                    
                </div>
                
            </div>
        </div>
    </div>
</template>


<script>

import Vue from 'vue'
import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin)

import VueQr from 'vue-qr';
import Header from '@/components/Header/header.vue';
import sidebar from '@/components/sidebar/sidebar.vue';
import articleList from '@/components/article-list/article-list.vue';

import { apiArticleLists,apiHandleArticleCollect ,apiUserHomeInfo,apiHandleFollow} from '@/api/app'

import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'index',
    components: {
        articleList,
        sidebar,
        Header,
        VueQr
    },

    data() {
        return {
            setResize: 'both',
            options:{},
            searchForm:{
                search:''
            },
            contentArr: [
               
            ],
            columns: [],
            arrIndex:[],
            loading:false,


            user_id:0,
            userHomeInfo:{},
            type:'',
            page_no:1,
            page_size:12,
            is_page:true,
            activeChannel:'active',
            activeChannel1:''

        }
    },

    mounted() {
        // const myDiv = this.$refs.pageLists
        window.addEventListener('scroll', this.handleScroll)



    },
    beforeDestroy() {
        // const myDiv = this.$refs.pageLists
        window.removeEventListener('scroll', this.handleScroll)
    },
    computed: {
        ...mapGetters(['config','userInfo','isLogin']),
    },

    provide() {
        return {
            
			reChatServe: this.reChatServe,
        }
    },

    async created() {
		
        if( this.$route.query.user_id){
            this.user_id = this.$route.query.user_id

            this.getArcileLists()

            this.getUserHome()
        }

        
        
    },

    methods: {
        
        handleTab(type){
            this.activeChannel = ''
            this.activeChannel1 = ''
            if( type == 0){
                this.activeChannel = 'active'
                this.type = ''
            } else {
                this.activeChannel1 = 'active'
                this.type = 'user_collect'
            }

            this.page_no =  1
            this.is_page = true
            this.getArcileLists()
        },
        handleScroll($event){
            
            const scrollHeight = document.documentElement.scrollHeight // 页面总高度
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条距离顶部的高度
            const clientHeight = document.documentElement.clientHeight // 视口高度

            if (scrollTop + clientHeight >= scrollHeight  && this.is_page) {
                // do something when the page is scrolled to the bottom
                this.page_no = this.page_no + 1
                this.getArcileLists()
            }

        },

        getUserHome(){

            const {page_no ,page_size,type,user_id} = this
            apiUserHomeInfo({
                user_id:user_id,
            }).then(data => {

                this.userHomeInfo = data
            }).catch(err => {
                
            })
        },

        getArcileLists(){

            const {page_no ,page_size,type,user_id} = this
            apiArticleLists({
                user_id:user_id,
                type:type,
                page_no:page_no,
                page_size:page_size,
            }).then(data => {
                if(data.lists.length <=0 ){
                    this.is_page = false
                }
               // 如果是第一页需手动置空列表
                if (page_no == 1) this.contentArr = []
                // 重置列表数据
                this.contentArr = [...this.contentArr, ...data.lists]
            }).catch(err => {
                
            })
        },

        // 关注取关用户
        handleFollow(){
            
        
            var that = this
            if (!this.isLogin) return this.$Router.push("/login");
            
            apiHandleFollow({
                user_id:this.user_id,
                is_follow: 1
            }).then((res) => {
                this.getUserHome()
                
            }).catch(err => {
            })
            
        },

    },
}
</script>


<style lang="scss" scoped>

    html,body,#app{
        background:#ffffff;
    }
    .header-container{
        background:#ffffff;
    }
    .contain{
        width:1700px;
        margin: 0 auto;
    }

    .main-container{
        display: flex;
    }

    .overlay-scrollbars{
        height:399px;
    }
    .main-content{
        width: 100%;
        padding-left: 282.66667px;
        .main-userinfo{
            display:flex;
            justify-content: center;
            padding:85px 0 20px 35px;
            text-align: center;
            .avatar{
                width:250px;
            }

            .info-part{
                width:450px;
                text-align: left;
                padding-top:10px;
                .username{font-size:26px; font-weight:600;}
                .sn{margin:10px 0 ;}
                .user-interactions{
                    color:#33333399; margin:10px 0 ;
                    span{ margin-right:6px;}
                }
            }
        }

        .main-page{
            padding:15px 0 20px 35px;
        }
        .channel-container{
            height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .channel{
            cursor: pointer;
            border-radius: 40px;
            font-size: 16px;
            color: #333;
            background: #ffffff;
            border: none;
            padding: 8px 15px;
            font-weight: 500;
        }
        .channel.active{
            background: #f8f8f8;
            font-weight:600;
            color: #333;
        }
        .page-list{
            width: 100%;
            transition: width .5s;
            margin: 0 auto;
            justify-content: space-around;
            transition: all 0.5s ease-in-out;

            .note-item {
                width: 245px;
                justify-content: center;
                align-items: center;
                transition: all 0.5s ease-in-out;
                margin:0 20px 0 10px;
            }
        }
    }

</style>
